import Holding from "./Holding";
import Prices from "./Prices";
import { Transaction } from "./Transaction";

export default class Summarize {
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // graph
    static graph(holdings:Holding[], end:Date) {
        const assets : [number|string,number|string][] = []
        const {transactions,holdingIds,qty,startYear,endYear,endYYMM,startYYMM} = this._init(holdings, end)
        for(let year=startYear; year<=endYear; year++) {
            let month = year==startYear ? startYYMM%100 : 0
            for(month; month<12; month++) {
                const yymm = year*100+month
                if (yymm>endYYMM) break;
                assets.push([`${year}-${(month+1).toString().padStart(2,"0")}`, this._summarize(holdingIds, yymm, transactions, qty)])
            }
        }
        console.log("here", assets.flat())
        return assets
    }
    private static _summarize(holdingIds:Record<string, Holding>, yymm:number, trans:Record<string,Transaction[]>, qty:Record<string,number>) {
        let sum = 0;
        const today = new Date()
        const todayYYMM = today.getFullYear()*100 + (today.getMonth())
        for(const id in trans){
            const ts = trans[id]
            const holding = holdingIds[id]
            const exchange = holding.exchange;
            while(ts.length) {
                const t = ts[0]
                const ym = t.date.getFullYear()*100+t.date.getMonth()
                if (ym>yymm) break;
                if (t.isBuyOrSell || t.isInterest || t.isAdjust) qty[id] += t.quantity;
                ts.shift()
            }
            const price = Prices.i.getHistoricPrice(id, yymm==todayYYMM ? today : new Date(~~(yymm/100), (yymm%100)-1, 1, 20, 0, 0))
            if (qty[id]) sum += qty[id] * price * exchange
        }
        return sum
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // export data
    static data(holdings:Holding[], end:Date){
        const {transactions,holdingIds,qty,startYear,endYear,endYYMM,startYYMM} = this._init(holdings, end)
        const tickers = Object.keys(holdingIds).sort()
        const assets : Array<any>[] = [["date",...tickers,"total"]]
        for(let year=startYear; year<=endYear; year++) {
            let month = year==startYear ? startYYMM%100 : 0
            for(month; month<12; month++) {
                const yymm = year*100+month
                if (yymm>endYYMM) break;
                assets.push([`${year}-${(month+1).toString().padStart(2,"0")}`, ...this._values(tickers, holdingIds, yymm, transactions, qty)])
            }
        }
        return assets
    }
    private static _values(tickers:string[], holdingIds:Record<string, Holding>, yymm:number, trans:Record<string,Transaction[]>, qty:Record<string,number>) {
        var total = 0;
        const ret : number[] = []
        const today = new Date()
        const todayYYMM = today.getFullYear()*100 + (today.getMonth()-1)
        for(const id of tickers){
            const ts = trans[id]
            const holding = holdingIds[id]
            const exchange = holding.exchange
            while(ts.length){
                const t = ts[0]
                const ym = t.date.getFullYear()*100+t.date.getMonth()
                if (ym>yymm) break;
                if (t.isBuyOrSell || t.isInterest || t.isAdjust) qty[id] += t.quantity;
                ts.shift()
            }
            const price = Prices.i.getHistoricPrice(id, yymm==todayYYMM ? today : new Date(~~(yymm/100)))
            const sum = price*(qty[id]||0)*exchange
            ret.push(sum)
            total += sum
        }
        ret.push(total)
        return ret
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // init
    private static _init(holdings:Holding[], end:Date=new Date()){
        const transactions : Record<string,Transaction[]> = {}
        const holdingIds : Record<string, Holding> = {}
        const qty : Record<string,number> = {}
        const endYear = end.getFullYear()
        const endYYMM = end.getFullYear()*100 + end.getMonth()
        
        let startYear = endYear;
        let startYYMM = endYYMM
        for(const holding of holdings) {
            if (holding.transactions.length==0) continue

            holdingIds[holding.id] = holding
            qty[holding.id] = 0;

            const trans = transactions[holding.id] = holding.transactions.slice(0).sort((l,r) => l.date<r.date ? -1 : 1)
            const year = trans[0].date.getFullYear()
            const yymm = trans[0].date.getFullYear()*100 + trans[0].date.getMonth()
            if (yymm<startYYMM) {
                startYYMM = yymm;
                startYear = year
            }
        }
        return {startYYMM, startYear, endYear, endYYMM, transactions, holdingIds, qty}
    }
}
